import { httpInstance } from '@/services/httpInstance';

export const getAmountService = async () => {
  let res;
  const endpoint = '/back-office/v1/all';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export const getAmountByIdService = async (amountId) => {
  let res;
  const endpoint = `/back-office/v1/id/${amountId}`;
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};
